import { EXAM_STAGES } from '../constants/config'
import BankBuildingScreen from '../exam/bankBuildingScreen'
import GradingScreen from '../exam/gradingScreen'
import PracticeMode from '../exam/practiceMode'
import ResultsScreen from '../exam/resultsScreen'
import SetupScreen from '../exam/setupScreen'
import VirtualMode from '../exam/virtualMode'
import { useExam } from '../hooks'

const STAGE_MAP = {
  [EXAM_STAGES.SETUP]:     SetupScreen,
  [EXAM_STAGES.BUILDING]:  BankBuildingScreen,
  [EXAM_STAGES.PRACTICE]:  PracticeMode,
  [EXAM_STAGES.VIRTUAL]:   VirtualMode,
  [EXAM_STAGES.GRADING]:   GradingScreen,
  [EXAM_STAGES.RESULTS]:   ResultsScreen,
}

export default function ExamPage() {
  const { state } = useExam()
  const Screen    = STAGE_MAP[state.stage] ?? SetupScreen
  return <Screen />
}
